import Long from 'long';
import {
  IMCChannelShownFields,
  MCCreateChannelResponse,
  SignalAuthorizationResponse,
  SignalChannelState,
  entities,
} from '../../../api/proto';
import {randomUint8Array, uint8ArrayToUuid} from '../../../utils/arrayUtils';
import wait from '../../../utils/wait';
import Channel from '../Channel';
import {ChannelsUpdaterEvent} from '../ChannelsUpdater';
import Signal from './Signal/Signal';

export class SignalEmulator extends Signal {
  createChannel = async (shownFields?: IMCChannelShownFields | null) => {
    console.debug('SignalEmulator.createChannel', shownFields);
    if (this.loading) {
      return {error: {message: 'In process'}, res: null};
    }

    const channelID = randomUint8Array();
    const createChannelRes = new MCCreateChannelResponse({
      channelID,
      signalAuthFlow: {
        status: SignalAuthorizationResponse.Status.OK,
        qrcode: uint8ArrayToUuid(channelID),
        expiresAt: Long.fromNumber(Math.floor(Date.now() / 1000) + 60),
      },
    });

    let newChannel: Channel | null = null;

    if (createChannelRes) {
      newChannel = new Channel(
        {
          channelID: createChannelRes?.channelID,
          shownFields: shownFields,
          type: entities.OzekonChannelType.OIT_SIGNAL,
          workspaceID: this.channels.workspace.id,
          state: {
            signal: {
              state: SignalChannelState.State.CREATE_CHANNEL,
            },
          },
        },
        this.channels.workspace,
      );
    }

    this.setLoading(true);
    await wait(2000);
    this.setLoading(false);

    this.emulateQrCodeScan(newChannel);

    return {error: null, res: createChannelRes, channel: newChannel};
  };

  private emulateQrCodeScan = async (newChannel: Channel | null) => {
    await wait(8000);
    this.emulateChannelsLoad(newChannel);
    await wait(1000);
    this.emulateUpdateEvent(newChannel);
  };

  private emulateChannelsLoad = (newChannel: Channel | null) => {
    console.debug('emulateChannelsLoad', newChannel?.uuid);
    newChannel &&
      this.channels.setChannels([
        ...this.channels.list,
        new Channel(
          {
            channelID: newChannel?.id,
            shownFields: newChannel.shownFields,
            type: newChannel.type,
            workspaceID: newChannel.workspace.id,
            state: {
              signal: {
                state: SignalChannelState.State.CREATE_CHANNEL,
              },
            },
          },
          this.channels.workspace,
        ),
      ]);
  };

  private emulateUpdateEvent = (newChannel: Channel | null) => {
    console.debug('emulateUpdateEvent', newChannel?.uuid);
    this.channels.workspace.updater.emit(ChannelsUpdaterEvent.UPDATE, {
      channelID: newChannel?.id,
      updateChannelState: {
        newState: {
          signal: {
            state: SignalChannelState.State.EVENT_LISTENING,
          },
          identifiers: {
            phone: '+101234567890',
          },
        },
      },
    });
  };

  public refreshQrCode = async (channel: Channel) => {
    if (this.loading) {
      return {error: {message: 'In process'}, res: null};
    }

    this.setLoading(true);
    await wait(500);
    this.setLoading(false);

    const res = new SignalAuthorizationResponse({
      status: SignalAuthorizationResponse.Status.OK,
      qrcode: uint8ArrayToUuid(randomUint8Array()),
      expiresAt: Long.fromNumber(Math.floor(Date.now() / 1000) + 60),
    });
    console.debug(`emulate refreshQrCode for channel ${channel.uuid}`);

    return {
      error: null,
      res,
    };
  };
}

export default SignalEmulator;
